import { Link } from "react-router-dom";
import AnimeCard from "@/components/feature/AnimeCard";
import { animes } from "@/mocks/animes";

export default function HotAnime() {
  const hot = [...animes].sort((a, b) => b.popularity - a.popularity).slice(0, 8);

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between gap-4 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="w-1 h-6 rounded-full bg-accent-500"></span>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">热门动漫推荐</h2>
            </div>
            <p className="text-sm text-foreground-500">精选本周热度最高的动漫作品，按人气实时排序</p>
          </div>
          <Link
            to="/anime"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            全部作品
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {hot.map((anime) => (
            <AnimeCard key={anime.id} anime={anime} />
          ))}
        </div>
      </div>
    </section>
  );
}